export const variables = {
    fontFamilyPrimary: 'Basel Grotesk',

    h1Size: '88px',
    h1Line: '90px',
    h1Weight: 635,
    mobileH1Size: '44px',
    mobileH1Line: '42px',
    mobileH1Weight: 635,
    
    h2Size: '60px',
    h2Line: '64px',
    h2Weight: 635,
    mobileH2Size: '32px',
    mobileH2Line: '32px',
    mobileH2Weight: 635,
    
    h3Size: '48px',
    h3Line: '51px',
    h3Weight: 635,
    mobileH3Size: '29px',
    mobileH3Line: '32px',
    mobileH3Weight: 635,
    
    h4Size: '44px',
    h4Line: '47px',
    h4Weight: 635,
    mobileH4Size: '29px',
    mobileH4Line: '32px',
    mobileH4Weight: 635,

    textSize: '32px',
    textLine: '36px',
    textWeight: '450',
    textMargin: '0px 0px 30px 0px',
    mobileTextSize: '15px',
    mobileTextLine: '18px',
    mobileTextWeight: '450',
    mobileTextMargin: '0px 0px 20px 0px',
    
    smallSize: '24px',
    smallLine: '30px',
    smallWeight: '450',
    mobileSmallSize: '15px',
    mobileSmallLine: '18px',
    mobileSmallWeight: '450',
    
    bannerTitleSize: '30px',
    bannerTitleLine: '34px',
    bannerTitleWeight: 635,
    mobileBannerTitleSize: '15px',
    mobileBannerTitleLine: '17px',
    mobileBannerTitleWeight: 635,
    
    footerHeadingSize: '22px',
    footerHeadingLine: '25px',
    footerHeadingWeight: 635,
    mobileFooterHeadingSize: '20px',
    mobileFooterHeadingLine: '25px',
    mobileFooterHeadingWeight: 635,
    
    footerLinkSize: '20px',
    footerLinkLine: '25px',
    footerLinkWeight: '450',
    mobileFooterLinkSize: '20px',
    mobileFooterLinkLine: '25px',
    mobileFooterLinkWeight: '450',
    
    footerSmallSize: '15px',
    footerSmallLine: '19px',
    footerSmallWeight: 450,
    mobileFooterSmallSize: '14px',
    mobileFooterSmallLine: '16px',
    mobileFooterSmallWeight: 450,
    
    cardSize: '32px',
    cardLine: '32px',
    cardWeight: 635,
    mobileCardSize: '30px',
    mobileCardLine: '31px',
    mobileCardWeight: 635,
    
    formSize: '24px !important',
    formLine: '24px !important',
    formWeight: 450,
    mobileFormSize: '19px !important',
    mobileFormLine: '19px !important',
    mobileFormWeight: 450,
    
    paginationSize: '24px !important',
    paginationLine: '24px !important',
    paginationWeight: 635,
    mobilePaginationSize: '19px !important',
    mobilePaginationLine: '19px !important',
    mobilePaginationWeight: 635,

    buttonSize: '21px',
    buttonSmallSize: '14px',
    menuSize: '20px',

    maxWidth: '1450px',
    bigRadius: '30px',
    smallRadius: '15px',

    mobileSize: '22px',
    mobileLine: '22px',
    mobileWeight: 450
}

export const colors = {
    primary: '#EF4372',
    secondary: '#3E6678',

    black: '#000000',
    white: '#ffffff',
    grey: '#707070',
    blue: '#3E6678',
    red: '#EF4372',

    h1: '#EF4372',
    h2: '#EF4372',
    h3: '#3E6678',
    h4: '#000000',

    buttonPrimary: '#EF4372',
    buttonPrimaryText: '#ffffff',
    buttonSecondary: '#3E6678',
    buttonSecondaryText: '#ffffff',

    lightGrey: '#F6F5F5',
    lightGrey2: '#EDECEC',
    lightRed: 'rgba(239, 67, 114, 0.05)',
    lightBlue: '#86BCD3',
    lightGreen: '#EDEEDF',

    dark: '#07131e',
    darkBlue: '#2C3C44',
    darkRed: '#AB1E44',

    shadow: 'rgba(0,0,0,0.2)',
    shadowHero: 'linear-gradient(180deg,rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.35) 73%, rgba(0, 0, 0, 0.5) 100%, rgba(0, 0, 0, 0.5) 0%)'
};

export const devices = {
    sizeSmall: '480px',
    sizeMobile: '640px',
    sizeTablet: '768px',
    sizeLaptop: '1024px',
    sizeDesktop: '1280px',
    size2K: '1536px',
    size4K: '1920px',
};